import { mapState } from 'vuex'
import { globalConst as native, modulesName, modalTitle } from 'lib/const'
import { isEmptyObject } from 'lib/utils'

const downLoadMixin = {
  data () {
    return {}
  },
  async created () {
    await this.checkDownLoader()
  },
  methods: {
    downLoadPack (pack) {
      if (!this.downLoaderServerUrl) {
        this.$f7.dialog.alert('模块联网中，请稍等片刻...', modalTitle)
        return
      }
      let {dispatch} = this.$store
      let dst_dir = 'USER/CUSTOM'
      let downdab = pack[`downdab${pack.line ? pack.line : 1}`]
      dispatch({
        baseUrl: this.downLoaderServerUrl,
        type: native.downLoad,
        url: downdab,
        dst_dir,
        resId: pack.id,
        flag: 'end'
      }).then(() => {
        this.$store.state.downLoader.process.downLoadText = '下载中...'
        this.executeDownLoaderTask(pack)
      }).catch((error) => {
        this.$f7.notification.create({
          icon: '<i class="icon demo-icon"></i>',
          title: modalTitle,
          subtitle: error,
          closeTimeout: 3000,
        }).open()
      })
    },
    executeDownLoaderTask (pack) {
      let {dispatch} = this.$store
      if (this.$store.state.downLoader.pollTask) {
        return
      }
      this.$store.state.downLoader.pollTask = setInterval(() => {
        dispatch({
          type: native.queryDownLoadProcess,
          baseUrl: this.downLoaderServerUrl
        }).then(({data}) => {
          this.$store.state.downLoader.process.packId = pack.id
          this.$store.state.downLoader.process.fileName = pack.iname
          if (data.hasTask) {
            this.$store.state.downLoader.process.value = parseFloat(Number(data.processBar).toFixed(2))
          } else {
            clearInterval(this.pollTask)
            this.$store.state.downLoader.pollTask = null
            this.$store.state.downLoader.process.downLoadText = '下载'
            this.$f7.dialog.confirm('下载完成，是否跳转至安装列表?', modalTitle, () => {
              this.$store.commit('setActiveTabbarItem', 'home')
              this.$f7router.navigate('/home?tabIdx=3', {clearPreviousHistory: true})
            })
          }
        })
      }, 3000)
    },
    checkDownLoader () {
      if (!this.downLoaderServerUrl) {
        return
      }
      let {dispatch} = this.$store
      dispatch({
        type: native.queryDownLoadProcess,
        baseUrl: this.downLoaderServerUrl
      }).then(({data}) => {
        const {hasTask, resId} = data
        if (hasTask) {
          this.$store.dispatch({
            type: native.resDetail,
            id: resId
          }).then(({data}) => {
            this.executeDownLoaderTask(data)
          })
        }
      })
    }
  },
  computed: {
    ...mapState({
      downLoaderServerUrl: ({downLoader}) => downLoader.downLoaderServerUrl,
      pollTask: ({downLoader}) => downLoader.pollTask
    })
  }
}
export default downLoadMixin
